import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Eyebrow, Reveal } from "./Reveal";

export default function Ariel() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  return (
    <section id="ariel" ref={ref} data-testid="ariel-section" className="relative bg-[#0D0908] border-y border-[#D9B47A]/10 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-10 py-28 sm:py-40 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative overflow-hidden aspect-[3/4] max-w-[480px] [clip-path:polygon(0_6%,100%_0,100%_94%,0_100%)]">
            <motion.img style={{ y, scale: 1.2 }} src="/images/goddess-ariel.jpg" alt="Goddess Ariel (Amy-Renee Hovorka) holding her book The Tantric Temple" className="absolute inset-0 w-full h-full object-cover object-top" />
          </div>
        </div>
        <div className="lg:col-span-7 order-1 lg:order-2">
          <Reveal>
            <Eyebrow n="VIII">The Executive & The Priestess</Eyebrow>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-7xl mt-8 leading-[1]">
              Goddess <em className="text-[#D9B47A]">Ariel</em>
            </h2>
            <p className="font-tt-mono text-[12px] uppercase tracking-[0.3em] text-[#A8998C] mt-4">
              Amy-Renee Hovorka · Founder, The Tantric Temple
            </p>
            <p className="mt-10 text-base sm:text-lg text-[#CFC2B6] leading-relaxed max-w-2xl">
              Goddess Ariel is not a persona created to appear mystical. She is the tantric embodiment of Amy-Renee
              Hovorka — a strategic transformation leader across Australia and the Middle East — and the priestess voice
              through which sensuality, spirituality and embodied wisdom are offered.
            </p>
            <p className="mt-6 text-base sm:text-lg text-[#CFC2B6] leading-relaxed max-w-2xl">
              Architect of the Orgasm Matrix and creator of the 13 Gates to Ecstasy, she translates high-voltage
              energetics into structured, repeatable somatic frameworks: the union of the practical and the mystical.
            </p>
          </Reveal>
          <Reveal delay={0.15} className="mt-14 grid grid-cols-3 gap-6 max-w-2xl">
            {[
              ["20+", "years in strategic transformation"],
              ["$100M+", "documented savings delivered"],
              ["4", "pillars: spirit, psyche, philosophy, quantum"],
            ].map(([n, t]) => (
              <div key={n} className="border-t border-[#D9B47A]/25 pt-5">
                <p className="font-display text-3xl sm:text-4xl text-[#D9B47A]">{n}</p>
                <p className="text-[13px] text-[#A8998C] mt-2 leading-snug">{t}</p>
              </div>
            ))}
          </Reveal>
        </div>
      </div>
    </section>
  );
}
